import {
  CloseCircleFilled,
  EyeFilled,
  EyeInvisibleFilled,
} from '@ant-design/icons';
import React, { useState } from 'react';
import Input from 'src/components/Antd/Input/Input';

const SecretInput = (props) => {
  const { editable, value, onChange, onEdit, size, secretProps, disabled } =
    props;
  const [showSecret, setShowSecret] = useState(false);

  const handleOnChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  const handleToggleSecret = () => {
    setShowSecret(!showSecret);
  };

  return editable ? (
    <Input
      size={size || 'large'}
      value={value}
      disabled={disabled}
      onChange={(e) => {
        handleOnChange(e);
      }}
      allowClear
      suffix={
        <div style={{ cursor: 'pointer' }} onClick={handleToggleSecret}>
          {showSecret ? (
            <EyeFilled rev={undefined} style={{ color: '#61d77c' }} />
          ) : (
            <EyeInvisibleFilled rev={undefined} />
          )}
        </div>
      }
      type='text'
      style={
        showSecret
          ? {}
          : {
              WebkitTextSecurity: 'disc',
              textSecurity: 'disc',
              MozTextSecurity: 'disc',
            }
      }
      {...(secretProps || {})}
    />
  ) : (
    <Input
      value={value}
      size={size || 'large'}
      suffix={<CloseCircleFilled rev={undefined} onClick={onEdit} />}
      disabled={disabled}
    />
  );
};

export default SecretInput;
